import React from 'react';
import Chosing from './chosing';
import TrueOrFalse from './TrueOrFalse';

const Questions = () => {
    return (
        <>
            <Chosing/>
            <TrueOrFalse/>
        </>
    );
};

export default Questions;